import React from "react";
import PropTypes from "prop-types";
import FilterActionButtons from "./FilterActionButtons";
import FilterSelections from "./FilterSelections";

const FilterBox = ({
  handleSearch,
  filterValuesLogic,
  loadingDashboardData,
  toggeleMissingSubIds,
  viewMissingSubIds,
  setViewMissingSubIds,
  dashboardDataHook,
  handleShowMissingSubids,
  downloadReport
}) => {
  const { selectionAddActions, filterValues, dataLists, clearAllSelection } =
    filterValuesLogic;

  return (
    <div className="flow-content dashboard-report__filters">
      <FilterSelections
        dataLists={dataLists}
        filterValues={filterValues}
        selectionAddActions={selectionAddActions}
      />
      <FilterActionButtons
        handleSearch={handleSearch}
        loadingDashboardData={loadingDashboardData}
        clearAllSelection={clearAllSelection}
        toggeleMissingSubIds={toggeleMissingSubIds}
        viewMissingSubIds={viewMissingSubIds}
        setViewMissingSubIds={setViewMissingSubIds}
        dashboardDataHook={dashboardDataHook}
        showMissingSubids={handleShowMissingSubids}
        downloadReport={downloadReport}
      />
    </div>
  );
};

FilterBox.propTypes = {
  handleSearch: PropTypes.func.isRequired,
  filterValuesLogic: PropTypes.object.isRequired
};

export default FilterBox;
